module.exports = __webpack_public_path__ + "img/dacu.da6169d6.png";